<template>
  <div id="app" class="App" :class="{'short': isShortPage}">
    <core-header />
    <main class="Content">
      <transition  name="fade" mode="out-in">
        <router-view/>
      </transition>
    </main>
    <core-footer />
  </div>
</template>

<script>
import Footer from '@/components/core/Footer'
import Header from '@/components/core/Header'

export default {
  name: 'App',
  components: {
    'core-footer': Footer,
    'core-header': Header
  },
  computed: {
    isShortPage() {
      return this.$route.meta.isShortPage
    }
  }
}
</script>

<style lang="scss">
.App {
  min-height: 100vh;
  width: 100%;
  position: relative;
  &.short {
    padding-bottom: $min-footer-width;
    &>.Footer {
      position: absolute;
      bottom: 0;
    }
  }
}
.Content {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
</style>
